import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { purgeStaleAuthOnBoot, installAuthInterceptor } from "@/lib/auth";

// Guard against the "returning-user glitch" — stale/expired JWT in localStorage
// used to leave the app in a half-authed state (every API call 401s). We now
// wipe expired tokens BEFORE React renders, then let a global axios 401 handler
// clear anything the server rejects mid-session.
purgeStaleAuthOnBoot();
installAuthInterceptor();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
